const getAddress = ({ address, properties, text, place_name }) => {
  // Get the explicit address if Mapbox returns it
  if (properties?.address) {
    return properties.address;
  }

  // Otherwise, get the address by piecing it together
  if (address && text) {
    return `${address} ${text}`.trim();
  }

  // Kenya has no street addressing to fall back on: a facility resolves to a
  // POI or a ward/locality with no house number, so the full Mapbox label is
  // the only human-readable address we get. Coordinates are the canonical
  // location either way, so accept the label rather than blocking signup.
  if (place_name) {
    return place_name;
  }

  return undefined;
};

export { getAddress };
